import { NextPageContextEnhanced } from "../../types/page";
import CacheManager from "../classes/cacheManager/CacheManager.class";

export function applyCacheManager(context: NextPageContextEnhanced) {
    context.cacheManager = CacheManager.getInstance(context);
}
